<template>
	<div class="products">

		<!-- page-heading -->
		<page-heading :show="true" pageTitle="HEADER_PRODUCTS"></page-heading>

		<div class="columns">

			<div class="col-main">

				<!-- show loading indicator -->
				<loading-indicator :loading="isLoading"></loading-indicator>

				<div v-if="!isLoading" class="products">

					<!-- Message Box for "Industriepartner" users only -->
					<alert type="info" class="infoSpecial" :closable="true" v-if="userRole == 'Industriepartner'">
						<div v-html="infoTextIndustriepartner"></div>
					</alert>

					<v-client-table ref="tblProducts" name="tblProducts" :data="table.tblData"
						:columns="table.tblColumns" :options="table.tblOptions" class="noFirstColumn">

						<!-- before table: FILTER OPTIONS -->
						<template slot="beforeTable">

							<!-- search -->
							<div class="control has-icon search is-pulled-left">
								<input class="input" type="text" v-model.trim="filterSearch" placeholder="Suchbegriff">
								<i class="fa fa-search" aria-hidden="true"></i>
							</div>

							<!-- filter -->
							<div class="columns filters" style="padding-left: 5px;">

								<div class="column">
									<form-input inputType="select" label="PRODUCTS-FILTER" :showLabelInOptions="true"
										:showLabel="false" :selectOptions="filterMutationOptions"
										v-model="filterStatus"></form-input>
								</div>

								<span :class="[filterIsActive ? 'is-blue' : 'is-disabled', 'button', 'reset-filter']"
									@click="resetFilter"
									:title="filterIsActive ? 'Klick um Filter zurückzusetzen' : ''">
									<span class="icon is-small"><i class="icon-ak-reset" aria-hidden="true"></i></span>
								</span>

							</div>

						</template>


						<!-- status -->
						<template slot="status" slot-scope="props">
							<!-- <div class="status">{{ props.row.status }}</div> -->
						</template>

						<!-- picture -->
						<template slot="picture" slot-scope="props">
							<template v-if="props.row.productAssets.length > 0">
								<div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImage(props.row)"
									:key="props.row.id"></div>
							</template>
						</template>

						<!-- name -->
						<template slot="name" slot-scope="props">
							<strong><span v-html="props.row.displayName"></span></strong>
							<template v-if="props.row.manufacturer != null"><br /><span class="manufacturer">{{
								props.row.manufacturer.name }}</span></template>
							<template v-if="props.row.contactPersonData != null"><span class="contactPerson">{{
								props.row.contactPersonData }}</span></template>
						</template>

						<!-- product variants -->
						<template slot="variants" slot-scope="props">

							<div v-if="props.row.productVariants.length > 0" class="productVariants">

								<div class="columns" v-for="productVariant in props.row.productVariants"
									:key="productVariant.id">

									<div class="column is-narrow">
										{{ productVariant.id }}
									</div>

									<div class="column is-narrow">
										{{ productVariant.name }}
									</div>

									<div class="column is-narrow">
										€ {{ formatPoint2Comma(productVariant.price) }}
									</div>

									<div class="column is-narrow">
										{{ productVariant.extRef }}
									</div>

									<div class="column" v-if="userRole != 'Industriepartner'">
										<template v-if="hasVoucher(productVariant, props.row)">{{
											getVoucherDiscount(productVariant, props.row) }}</template>
									</div>

								</div>

							</div>

						</template>

						<!-- placementCode -->
						<template slot="placementCode" slot-scope="props">
							{{ props.row.placementCode }}
						</template>

						<!-- productType -->
						<template slot="productType" slot-scope="props">
							<template v-if="props.row.type">
								<lang :labelKey="'PRODUCT_TYPE-' + props.row.type.name"></lang>
								<!--<lang :labelKey="'PRODUCT_TYPE-'+Object.values(productTypes).find((pt => pt.id == props.row.type)).name"></lang>	-->
							</template>
						</template>

						<!-- POSITION IN CATALOG -->
						<template slot="catalogPosition" slot-scope="props">

							<template v-if="props.row.contentElementData && props.row.contentElementData.length > 0">
								<small>Seite:

									<template v-for="contentElementData in props.row.contentElementData"
										v-if="contentElementData.contentElement != null && contentElementData.contentElement.catalogPageElements != null">

										<span
											v-for="(pageEl, index) in contentElementData.contentElement.catalogPageElements"
											class="pages">
											<span>{{ pageEl.catalogPage.sortorder }}</span>
										</span>

									</template>

								</small>
							</template>

						</template>

					</v-client-table>

				</div>

			</div>



			<div class="col-aside">

				<affix :offset="50">

					<!-- save -->
					<custom-button type="blue" name="PRODUCTS_BTN_PRODUCT_ADD" icon="icon-ak-hinzufuegen"
						@click.native="newProduct" v-if="userRole != 'Industriepartner'"></custom-button>

					<template v-if="!isLoading">
						<p>{{ stats.productsTotal }} Produkte gesamt</p>
					</template>

					<!-- export -->
					<export-button export="products" btnTitle="SITE_BTN_EXP_PRODUCTS"
						modalTitle="MODAL_HEADER-EXPORT_ACTIVE_PRODUCTS"
						v-if="userRole != 'Industriepartner'"></export-button>

					<!-- print -->
					<custom-button name="PRODUCTS-PRINT_PRODUCTS" type="dark" icon="icon-ak-print"
						@click.native="printProducts()" v-if="userRole == 'Administrator'"></custom-button>

					<!-- history -->
					<router-link :to="{ name: 'productsHistory' }" v-if="userRole == 'Administrator'">
						<custom-button name="CATALOG-BTN-LAST_CHANGES" type="dark"
							icon="icon-ak-history"></custom-button>
					</router-link>

				</affix>
			</div>

		</div>

	</div>

</template>


<script>
import Vue from 'vue';
import exportButton from '../utils/exportButton';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

	name: 'products',

	components: {
		exportButton
	},

	data() {

		var self = this;

		return {
			prevRoute: null,
			isLoading: true,
			// isFilterActive: false,

			filterSearch: null,
			filterStatus: null,

			stats: {
				productsTotal: '',
			},
			infoTextIndustriepartner: this.$t('MSG-BOX-INDUSTRIEPARTNER-PRODUCTS'),
			filterMutationOptions: [],
			manufacturers: [],

			table: {

				tblColumns: ['status', 'picture', 'name', 'variants', 'placementCode', 'productType', 'catalogPosition'],

				tblData: [],

				tblOptions: {
					trackBy: 'id',
					uniqueKey: 'id',
					perPage: 25,
					orderBy: {
						ascending: true,
						column: 'name'
					},
					saveState: true,
			
					// custom table headings - make them clickable for language Setting
					headings: {

						status: function (h) {
							// return <lang labelKey="PRODUCTS_TBL_HEADER-STATUS"></lang>
						},
						picture: function (h) {
							return <lang labelKey="PRODUCTS_TBL_HEADER-PICTURE"></lang>
						},
						name: function (h) {
							return <lang labelKey="PRODUCTS_TBL_HEADER-NAME"></lang>
						},
						variants: function (h) {
							if (this.userRole != 'Industriepartner') {
								return <lang labelKey="PRODUCTS_TBL_HEADER-VARIANTS"></lang>
							} else {
								return <lang labelKey="PRODUCTS_TBL_HEADER-VARIANTS_INDUSTRY"></lang>
							}
						},
						catalogPosition: function (h) {
							return <lang labelKey="PRODUCTS_TBL_HEADER-CATALOG_POSITION"></lang>
						},
						placementCode: function (h) {
							return <lang labelKey="PRODUCTS_TBL_HEADER-PLACEMENT_CODE"></lang>
						},
						productType: function (h) {
							return <lang labelKey="PRODUCTS_TBL_HEADER-PRODUCT_TYPE"></lang>
						},
					},

					sortable: ['name'],
					sortIcon: {
						base: 'fa',
						up: 'fa-sort-up',
						down: 'fa-sort-down',
						is: 'fa-sort'
					},
					filterByColumn: false,
					filterable: false,
					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					classes: {
						placementCode: 'placementCode',
						productType: 'productType',
					},

					pagination: {
						chunk: 5
					},

					skin: 'table is-striped is-hoverable is-fullwidth',

					initFilters: {
						filter: self.$store.getters.getProductsFilter('productList'),
						search: self.$store.getters.getProductsFilter('search'),
					},

					// custom filter functions
					customFilters: [
						{
							name: 'search',
							callback: function (row, string) {

								if (string == null || string == "") {
									return true;
								}

								var string = string.toLowerCase();
								return row.name != null && row.name.toLowerCase().indexOf(string) >= 0
									|| row.contactPersonData != null && row.contactPersonData.toLowerCase().indexOf(string) >= 0
									|| self.lookupProductVariants(row, string)
									|| row.manufacturer != null && row.manufacturer.name.toLowerCase().indexOf(string) >= 0;

							}
						},
						{
							name: 'filter',
							callback: function (row, filter) {

								// reset filter
								if (filter == null) {
									return true;
								}

								// filter products which have a voucher
								// AND are in current catalog
								else if (filter.name == "HAS_VOUCHER") {

									var hasVoucher = false;

									// check if there are any special vouchers
									if (row.productVouchers.length > 0) {
										hasVoucher = true;
									}

									// check if there is a productVariant with a voucher
									for (var i = 0; i < row.productVariants.length; i++) {
										if (row.productVariants[i].voucher != null) {
											hasVoucher = true;
										}
									}

									// check if product is also present in current catalog
									if (hasVoucher == true && row.contentElementData && row.contentElementData.length > 0) {

										for (var i = 0; i < row.contentElementData.length; i++) {

											if (row.contentElementData[i].contentElement && row.contentElementData[i].contentElement.catalogPageElements) {
												return true;
											}

										}

									}

									return false;

								}

								// filter products which are placed in the current catalog
								else if (filter.name == "PRODUCT_IN_CATALOG") {

									if (row.contentElementData && row.contentElementData.length > 0) {

										for (var i = 0; i < row.contentElementData.length; i++) {

											if (row.contentElementData[i].contentElement && row.contentElementData[i].contentElement.catalogPageElements.length > 0) {
												return true;
											}

										}
									}

								}

								// filter products which are "ready for layout"
								// == APPROVED && inCatalog
								else if (filter.name == "READY_FOR_LAYOUT") {

									if (row.status.id != 63)
										return false;

									if (row.contentElementData && row.contentElementData.length > 0) {

										for (var i = 0; i < row.contentElementData.length; i++) {

											if (row.contentElementData[i].contentElement && row.contentElementData[i].contentElement.catalogPageElements) {
												return true;
											}

										}
									}

								}

								// filter products which have status "inhaltl. Feedback Industrie" (id 71)
								else if (filter.name == "FEEDBACK_INDUSTRY") {

									if (row.contentElementData && row.contentElementData.length > 0) {

										for (var i = 0; i < row.contentElementData.length; i++) {

											if (row.contentElementData[i].contentElement && row.contentElementData[i].contentElement.catalogPageElements) {

												for (var j = 0; j < row.contentElementData[i].contentElement.catalogPageElements.length; j++) {

													if (row.contentElementData[i].contentElement.catalogPageElements[j].status == 71) {
														return true;
													}

												}
											}

										}
									}

								}

								// filter products with specific status
								else {

									if (row.status == null) {
										return true;
									}

									return row.status.id == filter.value;

								}

							}
						}

					],

					rowClassCallback: function (row) {

						if (row.status == null) {
							return '';
						}

						return `row-${row.id}` + ` status ` + row.status.name;

					}

				}
			}

		}
	},

	computed: {

		productTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_TYPES');
		},

		productAssetTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_ASSET_TYPES');
		},

		productStatus() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_STATUS');
		},

		filterIsActive() {
			return this.filterStatus != null || (this.filterSearch != '' && this.filterSearch != null);
		},

	},

	watch: {

		filterStatus(newVal, oldVal) {
			Event.$emit('vue-tables.tblProducts.filter::filter', newVal);
		},

		filterSearch(newVal, oldVal) {
			Event.$emit('vue-tables.tblProducts.filter::search', newVal);
		},

	},

	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.prevRoute = from
		})
	},

	created() {

		this.$nextTick(() => {
			if(this.prevRoute && this.prevRoute.name !== 'product') {
				localStorage.removeItem('scrollPosition');
			}
		})

		this.filterStatus = this.$store.getters.getProductsFilter('productList');
		this.filterSearch = this.$store.getters.getProductsFilter('search');

		if (this.$store.getters.getUserRole.name == 'Industriepartner') {
			this.fetchDataIndustry();
		} else {
			this.fetchData();
		}

		var self = this;

		for (let key in this.productStatus) {
			this.filterMutationOptions.push({
				name: 'STATUS-' + self.productStatus[key].name,
				value: self.productStatus[key].id
			})
		}

		this.filterMutationOptions.push(
			{ name: 'HAS_VOUCHER', value: 'HAS_VOUCHER' },
			{ name: 'PRODUCT_IN_CATALOG', value: 'PRODUCT_IN_CATALOG' },
			{ name: 'READY_FOR_LAYOUT', value: 'READY_FOR_LAYOUT' },
			{ name: 'FEEDBACK_INDUSTRY', value: 'FEEDBACK_INDUSTRY' }
		);

	},

	mounted() {

		Event.$on('vue-tables.tblProducts.row-click', function (data) {

			const scrollPosition = Math.round(document.documentElement.scrollTop);
			localStorage.setItem('scrollPosition', scrollPosition);
			this.$router.push({ name: 'product', params: { id: data.row.id } });

		}.bind(this));

	},

	beforeDestroy() {
		// localStorage.removeItem('scrollPosition');
		this.$store.commit('setProductsFilter', { type: 'search', value: this.filterSearch });
		this.$store.commit('setProductsFilter', { type: 'productList', value: this.filterStatus });
	},

	methods: {

		resetFilter() {
			this.filterSearch = null;
			this.filterStatus = null;
			Event.$emit('vue-tables.tblProducts.filter::filter', null);
		},

		newProduct() {
			// this.$router.push(this.$route.fullPath + '/neu/');
			this.$router.push({ name: 'productNew' });
		},

		hasVoucher(variant, row) {

			var qualifies = false;

			if (variant.voucher != null) {
				return true;
			}

			// also check special coupons
			if (row.productVouchers.length > 0) {

				row.productVouchers[0].productVoucherProductVariants.forEach(function (productVoucherProductVariant) {

					if (variant.id.toString() == productVoucherProductVariant.productVariant) {
						qualifies = true;
					}

				}.bind(this))

				return qualifies;
			}

			return false;

		},

		getVoucherDiscount(variant, row) {

			if (variant.voucher != null && variant.voucher != 0) {
				return '€ ' + this.formatPoint2Comma(variant.voucher.discount);
			}

			else if (row.productVouchers.length > 0 && row.productVouchers[0].discount > 0) {
				return '€ ' + this.formatPoint2Comma(row.productVouchers[0].discount);
			}

			else {
				return '-';
			}

		},


		printProducts() {

			// console.log("productList: ",  this.$store.getters.getProductsFilter('productList'));

			if (this.$store.getters.getProductsFilter('productList') == null) {

				return;

			} else {

				var url = `/katalog/produkte/print/${this.$store.getters.getProductsFilter('productList')}`;
				var win = window.open(url, '_blank');
				win.focus();

			}

			/*
			var url = '/katalog/produkte/print/' + (typeof this.$store.getters.getProductsFilter('productList') != 'undefined'
				? this.$store.getters.getProductsFilter('productList')
				: '');

			var win = window.open(url, '_blank');
			win.focus();
				*/
		},

		getImage(row) {

			// loop through the assets array and return the very frist which has a type of DEFAULT (65)
			for (var i = 0; i < row.productAssets.length; i++) {
				if (row.productAssets[i].asset != null && row.productAssets[i].type == this.productAssetTypes.DEFAULT.id) {
					return this.$config.assets + row.productAssets[i].asset['path'] + '/' + row.productAssets[i].asset['filename']
				}
			}
		},

		lookupProductVariants(row, string) {

			if (row.productVariants.length > 0) {

				var i = 0;
				for (var key in row.productVariants) {
					if (row.productVariants[key].extRef.indexOf(string) >= 0) {
						i++
					}
				}
				return i > 0 ? true : false;
			}

			return false;

		},

		fetchData() {

			this.isLoading = true;
			var self = this;

			// get manufacturers
			function getManufacturers() {
				return self.axios.get(self.$config.api + 'manufacturer');
			}

			// get apoData
			function getProducts() {
				// filters[catalogPage.catalog.id]='+self.catalogId+'&
				return self.axios.get(self.$config.api + 'product?include=productVariant.voucher,product.productVouchers,productVoucher.productVoucherProductVariants,product.contentElementData,contentElementData.contentElement,contentElement.catalogPageElements,catalogPageElement.catalogPage,catalogPage.catalog,product.manufacturer,product.status,product.contactPersonData,product.type,product.productVariants,product.productAssets,productAsset.asset&filters[productAssets.type]=64,65,NULL&groupBy=id&orderBy=productVariant.sortorder');
			}

			// make the request
			this.axios.all([getProducts(), getManufacturers()])

				.then(self.axios.spread(function (products, manufacturers) {

					self.table.tblData = products.data.product;
					self.stats.productsTotal = products.data.product.length;
					self.manufacturers = manufacturers.data;
					self.isLoading = false;

					// Scroll-Position nach dem Laden der Daten wiederherstellen
					const scrollPosition = localStorage.getItem('scrollPosition');
					if (scrollPosition) {
						// console.log("scroll to position: ", scrollPosition);
						self.$nextTick(() => {
							window.scrollTo({
								top: scrollPosition,
								left: 0,
								behavior: "smooth",
							});
						})
					}

				})).catch(function (error) {
					self.isLoading = false;
					console.log('Error: ', error.message);
				});
		},


		fetchDataIndustry() {

			this.isLoading = true;
			var manufacturerId = this.$store.getters.getUser.manufacturer.id;
			var self = this;

			// get apoData
			function getProducts() {

				return self.axios.get(self.$config.api + 'product?include=productVariant.voucher,product.productVouchers,productVoucher.productVoucherProductVariants,product.contentElementData,contentElementData.contentElement,contentElement.catalogPageElements,catalogPageElement.catalogPage,catalogPage.catalog,product.manufacturer,product.status,product.contactPersonData,product.type,product.productVariants,product.productAssets,productAsset.asset&filters[status]=45,63&filters[manufacturer]=' + manufacturerId + '&filters[productAssets.type]=64,65,NULL&groupBy=id&orderBy=productVariant.sortorder');

			}

			// make the request
			this.axios.all([getProducts()])

				.then(self.axios.spread(function (products) {

					self.table.tblData = products.data.product;
					self.stats.productsTotal = products.data.product.length;
					self.isLoading = false;

				})).catch(function (error) {
					self.isLoading = false;
					console.log('Error: ', error.message);
				});

		},

	}

}
</script>

<style lang="scss">
@import '../../assets/css/variables.scss';

.products table:not(.productVariants) .status>td:first-child::after {
	background: transparent;
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	height: 100%;
	width: 5px;
}

.products table:not(.productVariants) .status.ACTIVE>td:first-child::after,
.products table:not(.productVariants) .status.CREATED>td:first-child::after {
	background-color: $statusCreated;
}

.products table:not(.productVariants) .status.APPROVED>td:first-child::after {
	background-color: $statusPrintApproved;
}

.products table:not(.productVariants) .status.ARCHIVED>td:first-child::after {
	background-color: $statusArchived;
}

.products {

	th#VueTables_th--variants {
		min-width: 420px;
	}

	th#VueTables_th--productType {
		min-width: 200px;
	}

	th#VueTables_th--name {
		min-width: 300px;
	}

	th#VueTables_th--placementCode {
		min-width: 120px;
	}

	th#VueTables_th--productType {}

}
</style>

<style scoped></style>

<style>
.products .pages+.pages:before {
	content: ",";
}

.products tbody>tr>td:first-child {
	position: relative;
}

.products div.statusOUT {
	position: absolute;
	top: 50%;
	height: 2px;
	/* actual text will overlap! */
	margin-top: -1px;
	/* subtract half the height */
	line-height: 0px;
	/* centre the text on the base line */
	text-align: center;
	left: 50%;
	transform: translateX(-55%) rotate(270deg);
	white-space: nowrap;
	color: #888;
	font-family: arial;
	text-transform: uppercase;
	font-size: 10px;
}


/* products table */
.products {
	table-layout: fixed;
}

.products th:first-child {
	width: 15px;
}

.products th:nth-child(2) {
	width: 140px;
	text-align: left;
}

/*
	.products th:nth-child(3) {
		min-width: 200px;
	}
	.products th:nth-child(4) {
		min-width: 400px;
	}
	.products th:nth-child(5) {
		min-width: 200px;
		text-align: right;
	}
	*/

/* products table rows */
.products tbody>tr>td {
	height: 100px;
}

.products tbody td:nth-child(2) img {
	max-width: 80px;
	max-height: 80px;
	width: auto;
}

.products tbody td:last-child {
	text-align: right;
}

.products .imgWrapper {
	background-repeat: no-repeat;
	background-position: 50% 50% !important;
	background-size: 60%;
	width: 100px;
	height: 80px;
	margin: 0;
	background-color: #FFF;
	border: 1px solid #efefef;
	border-radius: 2px;
}

.products .imgWrapper[lazy=loading] {
	background-size: 30% !important;
}


.products span.manufacturer {
	margin: 4px 0 0 0;
	color: #888;
	font-style: italic;
	display: block;
}

.products span.contactPerson {
	margin: 12px 0 0 0;
	display: block;
}


/* sub table productVariants */
.products .productVariants {}

.products .productVariants .columns {
	margin: 0;
	padding: 0;
	font-size: 10px;
	/*border-bottom: 1px solid #eee;*/
}

.products .productVariants .columns:last-child {
	border-bottom: none;
}


.products .productVariants .columns .column {
	padding: 3px 5px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	border-right: 1px solid #ddd;
	margin: 3px 0;
}

.products .productVariants .columns .column:last-child {
	border-right: none;
	margin-bottom: 0;
}

/*
	.products tr:nth-child(even) .productVariants .columns .column {
		background: #EEE;
	}
	*/

/*
	.products .productVariants .columns .column:first-child {
		border-top-left-radius: 3px;
		border-bottom-left-radius: 3px;
	}
	.products .productVariants .columns .column:last-child {
		border-top-right-radius: 3px;
		border-bottom-right-radius: 3px;
	}
	*/



.products .productVariants .columns .column:first-child {
	min-width: 50px;
	width: 50px;
}

.products .productVariants .columns .column:nth-child(2) {
	min-width: 120px;
	width: 150px;
}

.products .productVariants .columns .column:nth-child(3) {
	min-width: 80px;
}

.products .productVariants .columns .column:nth-child(4) {
	width: 80px;
	max-width: 80px;
}

.products .productVariants .columns .column:nth-child(5) {
	min-width: 50px;
	text-align: left;
}


.products .VueTables__sort-icon.pull-right {
	float: none;
	margin: 0;
}

.products th:not(:first-child) .VueTables__sort-icon.pull-right {
	margin-left: 10px;
}
</style>
